import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleQCGuide from "@/pages/article-qc/page";
import ArticleShippingGuide from "@/pages/article-shipping/page";
import ArticleShoesGuide from "@/pages/article-shoes/page";
import ArticleHoodiesGuide from "@/pages/article-hoodies/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/superbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/superbuy-spreadsheet-qc-guide",
    element: <ArticleQCGuide />,
  },
  {
    path: "/article/superbuy-spreadsheet-shipping-guide",
    element: <ArticleShippingGuide />,
  },
  {
    path: "/article/best-superbuy-spreadsheet-shoes",
    element: <ArticleShoesGuide />,
  },
  {
    path: "/article/best-superbuy-spreadsheet-hoodies",
    element: <ArticleHoodiesGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;